import React, { useEffect, useState } from "react";
import api from "../../services/axios";
import useAuth from "../../hooks/useAuthContext";

function ListaAgenda(props) {
  const [body, setBody] = useState([]);
  const { usuario } = useAuth();


  useEffect(() => {
    // if (usuario && usuario.tipo === 'administracao') {
    handleLista();
    // }
  }, []);

  const handleLista = async () => {
    let lista = await api.get("/lista-agenda");
    let relatorioBody = lista.data.arrayAgenda.map((a) => {
      return (
        <tr>
          <td>{a.nome}</td>
          <td>{a.empresa}</td>
          <td>{a.dez40 ? a.dez40 : "Livre"}</td>
          <td>{a.onze20 ? a.onze20 : "Livre"}</td>
          <td>{a.doze ? a.doze : "Livre"}</td>
          <td>{a.doze40 ? a.doze40 : "Livre"}</td>
          <td>{a.quinze10 ? a.quinze10 : "Livre"}</td>
          <td>{a.quinze50 ? a.quinze50 : "Livre"}</td>
          <td>{a.dez403 ? a.dez403 : "Livre"}</td>
          <td>{a.onze203 ? a.onze203 : "Livre"}</td>
          <td>{a.doze3 ? a.doze3 : "Livre"}</td> 
          <td>{a.doze403 ? a.doze403 : "Livre"}</td>
          <td>{a.uma103 ? a.uma103 : "Livre"}</td>
        </tr>
      );
    });
    setBody(relatorioBody);
  };

  return (
    <div>
      <table>
        <thead>
          <th>Nome</th>
          <th>Empresa</th>
          <th>20/08/2025 - 10:40 as 11:10</th>
          <th>20/08/2025 - 11:20 as 11:50</th>
          <th>20/08/2025 - 12:00 as 12:30</th>
          <th>20/08/2025 - 12:40 as 13:10</th>
          <th>20/08/2025 - 15:10 as 15:40</th>
          <th>20/08/2025 - 15:50 as 16:20</th>
          <th>21/08/2025 - 10:40 as 11:10</th>
          <th>21/08/2025 - 11:20 as 11:50</th>
          <th>21/08/2025 - 12:00 as 12:30</th>
          <th>21/08/2025 - 12:40 as 13:10</th>
          <th>21/08/2025 - 13:10 as 13:40</th>
        </thead>
        <tbody>{body}</tbody>
      </table>
    </div>
  );
}

export default ListaAgenda;
